<template>
  <div>
    <h6
      v-if="memberTagData === null"
      class="heading-small text-muted mb-4 text-truncate"
    >
      Add Member Tag
    </h6>
    <h6 v-else class="heading-small text-muted mb-4 text-truncate">
      Edit Member Tag
    </h6>

    <form id="form-proper">
      <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
        <div class="row">
          <div class="col">
            <base-input label="Membership Program" required>
              <a-select
                v-model="formData.membership_program_id"
                :disabled="viewMode || memberTagData !== null"
              >
                <a-select-option
                  v-for="membership_program in membershipPrograms"
                  v-bind:value="membership_program.id"
                  v-bind:key="membership_program.id"
                >
                  {{ membership_program.name }}
                </a-select-option>
              </a-select>
              <div
                v-if="$v.formData.membership_program_id.$dirty"
                class="text-danger"
              >
                <div
                  class="error"
                  v-if="!$v.formData.membership_program_id.required"
                >
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Name" required>
              <a-input
                v-model.trim="$v.formData.name.$model"
                :disabled="viewMode"
              />
              <div v-if="$v.formData.name.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.name.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Status">
              <a-select v-model="formData.status" :disabled="viewMode">
                <a-select-option value="A"> Active </a-select-option>
                <a-select-option value="I"> Inactive </a-select-option>
              </a-select>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Description">
              <a-textarea
                v-model="formData.description"
                :auto-size="{ minRows: 5, maxRows: 5 }"
                :disabled="viewMode"
              />
            </base-input>
          </div>
        </div>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer()"
              >
                Cancel
              </b-button>
            </div>

            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <b-button
                    v-if="memberTagData === null"
                    size="sm"
                    variant="primary"
                    @click.prevent="createMemberTag"
                  >
                    Create
                  </b-button>

                  <b-button
                    v-else
                    size="sm"
                    variant="primary"
                    @click.prevent="confirmUpdate"
                    :disabled="viewMode"
                  >
                    Update
                  </b-button>
                </a-spin>
              </template>
            </div>

            <!-- <div class="col-auto" v-if="memberTagData === null">
              <template>
                <b-button
                  size="sm"
                  variant="primary"
                  @click.prevent="createMemberTag"
                >
                  Create Member Tag
                </b-button>
              </template>
            </div>
            <div class="col-auto" v-else>
              <template>
                <b-button
                  size="sm"
                  variant="primary"
                  @click.prevent="editMemberTag"
                  :disabled="viewMode"
                >
                  Update Member Tag
                </b-button>
              </template>
            </div> -->
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'MemberTagForm',
  props: {
    memberTagData: Object,
    viewMode: Boolean
  },
  data() {
    return {
      formSubmitting: false,
      formData: {
        membership_program_id: null,
        name: null,
        description: null,
        status: 'A'
      },
      membershipPrograms: []
    };
  },

  validations: {
    formData: {
      membership_program_id: { required },
      name: { required }
    }
  },

  methods: {
    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs'
      );
      this.membershipPrograms = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },

    async createMemberTag() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const response = await HTTPRequest.postRequest(
          '/api/v1/clp_member_tags',
          {
            member_tag: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been created.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      }
    },
    async editMemberTag() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const response = await HTTPRequest.putRequest(
          '/api/v1/clp_member_tags/' + this.memberTagData.id,
          {
            member_tag: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been updated.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      }
    },

    confirmUpdate() {
      this.$confirm({
        title: 'Confirm',
        content:
          "Changing the name of the tag will update all affected member's tag. Are you sure you want to continue?",
        options: {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        },
        onOk: () => {
          this.editMemberTag();
        }
      });
    },

    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
      this.$v.formData.$reset();
    },
    clearForm() {
      this.formData = {
        membership_program_id: null,
        name: null,
        description: null,
        status: 'A'
      };
    },
    setFormData() {
      if (this.memberTagData !== null) {
        const { membership_program_id, name, description, status } =
          this.memberTagData;

        this.formData = {
          membership_program_id,
          name,
          description,
          status
        };
      }
    }
  },
  created() {
    this.getMembershipPrograms();

    this.setFormData();
  },
  watch: {
    memberTagData: function (newVal) {
      if (newVal !== null) {
        this.setFormData();
      } else {
        this.clearForm();
      }
    }
  }
};
</script>

<style scoped></style>
